export const SocketStateEnum = {
  0: "Connecting",
  1: "Connected",
  2: "Closing",
  3: "Closed",
};

export const SmartDocumentWordAddInSocketMessageTypeEnum = {
  START_EDIT_IN_WORD: "edit_in_word",
  GET_CONTENT_FROM_WORD: "get_content_from_word",
  SEND_CONTENT_TO_LEGALE: "send_content_to_legale",
};
